import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
//import { ToastContainer } from "react-toastify";
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
//import "react-toastify/dist/ReactToastify.css";
import { Provider } from "react-redux";
import { store } from "./redux/store";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter basename={baseUrl}>
      <App />      
    </BrowserRouter>
  </Provider>
);